export const SUCCESS_GET_PRODUCTOSCOMERCIO = 'SUCCESS_GET_PRODUCTOSCOMERCIO'
export const FAILED_GET_PRODUCTOSCOMERCIO = 'FAILED_GET_PRODUCTOSCOMERCIO'
export const ERROR_GET_PRODUCTOSCOMERCIO = 'ERROR_GET_PRODUCTOSCOMERCIO'

export const SUCCESS_GET_IVA_COMERCIO = 'SUCCESS_GET_IVA_COMERCIO'
export const FAILED_GET_IVA_COMERCIO = 'FAILED_GET_IVA_COMERCIO'
export const ERROR_GET_IVA_COMERCIO = 'ERROR_GET_IVA_COMERCIO'

export const SUCCESS_GET_FACTURAS_COMERCIO = 'SUCCESS_GET_FACTURAS_COMERCIO'
export const FAILED_GET_FACTURAS_COMERCIO = 'FAILED_GET_FACTURAS_COMERCIO'
export const ERROR_GET_FACTURAS_COMERCIO = 'ERROR_GET_FACTURAS_COMERCIO'

export const SUCCESS_TRANSACCIONES_AGRUPADAS_CIERRELOTE = 'SUCCESS_TRANSACCIONES_AGRUPADAS_CIERRELOTE'
export const FAILED_TRANSACCIONES_AGRUPADAS_CIERRELOTE = 'FAILED_TRANSACCIONES_AGRUPADAS_CIERRELOTE'
export const ERROR_TRANSACCIONES_AGRUPADAS_CIERRELOTE = 'ERROR_TRANSACCIONES_AGRUPADAS_CIERRELOTE'

export const SUCCESS_TRANSACCIONES_DETALLES = 'SUCCESS_TRANSACCIONES_DETALLES'
export const FAILED_TRANSACCIONES_DETALLES = 'FAILED_TRANSACCIONES_DETALLES'
export const ERROR_TRANSACCIONES_DETALLES = 'ERROR_TRANSACCIONES_DETALLES'

export const SUCCESS_INCLUIR_TRANSACCIONES = 'SUCCESS_INCLUIR_TRANSACCIONES'
export const FAILED_INCLUIR_TRANSACCIONES = 'FAILED_INCLUIR_TRANSACCIONES'
export const ERROR_INCLUIR_TRANSACCIONES = 'ERROR_INCLUIR_TRANSACCIONES'

export const SUCCESS_EXCLUIR_TRANSACCIONES = 'SUCCESS_EXCLUIR_TRANSACCIONES'
export const FAILED_EXCLUIR_TRANSACCIONES = 'FAILED_EXCLUIR_TRANSACCIONES'
export const ERROR_EXCLUIR_TRANSACCIONES = 'ERROR_EXCLUIR_TRANSACCIONES'

export const SUCCESS_INCLUIR_ALL_TRANSACCIONES = 'SUCCESS_INCLUIR_ALL_TRANSACCIONES'
export const FAILED_INCLUIR_ALL_TRANSACCIONES = 'FAILED_INCLUIR_ALL_TRANSACCIONES'
export const ERROR_INCLUIR_ALL_TRANSACCIONES = 'ERROR_INCLUIR_ALL_TRANSACCIONES'

export const SUCCESS_GET_IMPUESTOS = 'SUCCESS_GET_IMPUESTOS'
export const FAILED_GET_IMPUESTOS = 'FAILED_GET_IMPUESTOS'
export const ERROR_GET_IMPUESTOS = 'ERROR_GET_IMPUESTOS'

export const SUCCESS_CREATE_IMPUESTOS = 'SUCCESS_CREATE_IMPUESTOS'
export const FAILED_CREATE_IMPUESTOS = 'FAILED_CREATE_IMPUESTOS'
export const ERROR_CREATE_IMPUESTOS = 'ERROR_CREATE_IMPUESTOS'

export const SUCCESS_BORRAR_IMPUESTOS = 'SUCCESS_BORRAR_IMPUESTOS'
export const FAILED_BORRAR_IMPUESTOS = 'FAILED_BORRAR_IMPUESTOS'
export const ERROR_BORRAR_IMPUESTOS = 'ERROR_BORRAR_IMPUESTOS'



export const SUCCESS_CONSULTAR_IMPUESTOS_PREDETERMINADOS = 'SUCCESS_CONSULTAR_IMPUESTOS_PREDETERMINADOS'
export const FAILED_CONSULTAR_IMPUESTOS_PREDETERMINADOS = 'FAILED_CONSULTAR_IMPUESTOS_PREDETERMINADOS'
export const ERROR_CONSULTAR_IMPUESTOS_PREDETERMINADOS = 'ERROR_CONSULTAR_IMPUESTOS_PREDETERMINADOS'

export const SUCCESS_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS = 'SUCCESS_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS'
export const FAILED_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS = 'FAILED_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS'
export const ERROR_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS = 'ERROR_ACTUALIZAR_IMPUESTOS_PREDETERMINADOS'

export const SUCCESS_CREAR_IMPUESTOS_PREDETERMINADOS = 'SUCCESS_CREAR_IMPUESTOS_PREDETERMINADOS'
export const FAILED_CREAR_IMPUESTOS_PREDETERMINADOS = 'FAILED_CREAR_IMPUESTOS_PREDETERMINADOS'
export const ERROR_CREAR_IMPUESTOS_PREDETERMINADOS = 'ERROR_CREAR_IMPUESTOS_PREDETERMINADOS'

export const SUCCESS_CONSULTAR_FACTURAS_PRESENTACION = 'SUCCESS_CONSULTAR_FACTURAS_PRESENTACION'
export const FAILED_CONSULTAR_FACTURAS_PRESENTACION = 'FAILED_CONSULTAR_FACTURAS_PRESENTACION'
export const ERROR_CONSULTAR_FACTURAS_PRESENTACION = 'ERROR_CONSULTAR_FACTURAS_PRESENTACION'


export const SUCCESS_CREAR_FACTURA_PRESENTACION= 'SUCCESS_CREAR_FACTURA_PRESENTACION'
export const FAILED_CREAR_FACTURA_PRESENTACION= 'FAILED_CREAR_FACTURA_PRESENTACION'
export const ERROR_CREAR_FACTURA_PRESENTACION= 'ERROR_CREAR_FACTURA_PRESENTACION'

export const SUCCESS_ACTUALIZAR_FACTURA_PRESENTACION= 'SUCCESS_ACTUALIZAR_FACTURA_PRESENTACION'
export const FAILED_ACTUALIZAR_FACTURA_PRESENTACION= 'FAILED_ACTUALIZAR_FACTURA_PRESENTACION'
export const ERROR_ACTUALIZAR_FACTURA_PRESENTACION= 'ERROR_ACTUALIZAR_FACTURA_PRESENTACION'

export const SUCCESS_BORRAR_FACTURA_PRESENTACION= 'SUCCESS_BORRAR_FACTURA_PRESENTACION'
export const FAILED_BORRAR_FACTURA_PRESENTACION= 'FAILED_BORRAR_FACTURA_PRESENTACION'
export const ERROR_BORRAR_FACTURA_PRESENTACION= 'ERROR_BORRAR_FACTURA_PRESENTACION'

export const SUCCESS_CONSULTAR_TASA_IVA = 'SUCCESS_CONSULTAR_TASA_IVA'
export const FAILED_CONSULTAR_TASA_IVA = 'FAILED_CONSULTAR_TASA_IVA'
export const ERROR_CONSULTAR_TASA_IVA = 'ERROR_CONSULTAR_TASA_IVA'


export const SUCCESS_CONSULTAR_TIPO_FACTURAS = 'SUCCESS_CONSULTAR_TIPO_FACTURAS'
export const FAILED_CONSULTAR_TIPO_FACTURAS = 'FAILED_CONSULTAR_TIPO_FACTURAS'
export const ERROR_CONSULTAR_TIPO_FACTURAS = 'ERROR_CONSULTAR_TIPO_FACTURAS'

export const SUCCESS_CONSULTAR_PARAMETROS_PRESENTACION = 'SUCCESS_CONSULTAR_PARAMETROS_PRESENTACION'
export const FAILED_CONSULTAR_PARAMETROS_PRESENTACION = 'FAILED_CONSULTAR_PARAMETROS_PRESENTACION'
export const ERROR_CONSULTAR_PARAMETROS_PRESENTACION = 'ERROR_CONSULTAR_PARAMETROS_PRESENTACION'

export const DOCU = "DOCU"
export const LIFE_TOAST_MESSAGE = 15000
export const REGEX = /data:.*base64,/
export const FAILED_VALIDATION = "FAILED_VALIDATION"
export const SUCCESS_VALIDATION = "SUCCESS_VALIDATION"

export const SUCCESS_OBTENER_IMAGEN_FACTURAS = 'SUCCESS_OBTENER_IMAGEN_FACTURAS'
export const FAILED_OBTENER_IMAGEN_FACTURAS = 'FAILED_OBTENER_IMAGEN_FACTURAS'
export const ERROR_OBTENER_IMAGEN_FACTURAS = 'ERROR_OBTENER_IMAGEN_FACTURAS'

export const SUCCESS_PRESENTACCION = 'SUCCESS_PRESENTACCION'
export const FAILED_PRESENTACCION = 'FAILED_PRESENTACCION'
export const ERROR_PRESENTACCION = 'ERROR_PRESENTACCION'

export const SUCCESS_ANULAR_PRESENTACCION = 'SUCCESS_ANULAR_PRESENTACCION'
export const FAILED_ANULAR_PRESENTACCION = 'FAILED_ANULAR_PRESENTACCION'
export const ERROR_ANULAR_PRESENTACCION = 'ERROR_ANULAR_PRESENTACCION'

export const SUCCESS_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA = "SUCCESS_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA"
export const FAILED_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA = "FAILED_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA"
export const ERROR_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA = "ERROR_CONSULTAR_IMPUESTOS_PRESENTACION_AUTOMATICA"

export const SUCCESS_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA = "SUCCESS_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA"
export const FAILED_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA = "FAILED_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA"
export const ERROR_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA = "ERROR_CONSULTAR_IMPUESTOS_DEFAULT_AUTOMATICA"

export const SUCCESS_TRANSACCIONES_MF = 'SUCCESS_TRANSACCIONES_MF'
export const FAILED_TRANSACCIONES_MF = 'FAILED_TRANSACCIONES_MF'
export const ERROR_TRANSACCIONES_MF = 'ERROR_TRANSACCIONES_MF'

export const SUCCESS_TRANSACCIONES_MF_DETALLES = 'SUCCESS_TRANSACCIONES_MF_DETALLES'
export const FAILED_TRANSACCIONES_MF_DETALLES = 'FAILED_TRANSACCIONES_MF_DETALLES'
export const ERROR_TRANSACCIONES_MF_DETALLES = 'ERROR_TRANSACCIONES_MF_DETALLES'

export const INICIADA_COMERCIO = "INICIADA COMERCIO";
export const RECHAZADA = "RECHAZADA";
export const GENERADO = "GENERADO";
export const PAGADO = "PAGADO";
export const INGRESADO = "INGRESADO";
export const TRANSFERIDO = "TRANSFERIDO";

export const GP_ID_COMBUSTIBLES_AFINES = 10
export const GP_ID_MANTENIMIENTO_FLOTA = 12
export const GP_ID_MANTENIMIENTO_FLOTA_NEW = 19

export const IMPUESTO_DECLARADO = 1
export const KB = 1000

export const IMPUESTO_MANUAL = 1;
export const IMPUESTO_AUTOMATICO = 0;
